import '../LoginStyle.css';
import { useNavigate } from 'react-router-dom';

function ResetPassword() {
  let navigate = useNavigate();
  
  return (
    <div className="container">
      <h2 className="title"> Reset Password</h2>
      <div className="box">
        <p className="text">New Password</p>
        <input className="input" type="password" placeholder="new password" />
        <p className="text">Confirm new password</p>
        <input className="input" type="password" placeholder="confirm new password" />
        <button className="btn" onClick={()=> navigate('/login')}>
          Enter
        </button>
      </div>
    </div>
  );
}

export default ResetPassword;
